import { Component, HostListener } from '@angular/core';
import { COMMON_MODULES } from '@src/app/core/constants';

interface Card {
  id: number;
  title: string;
  description: string;
  authorName: string;
  authorRole: string;
  avatarUrl: string;
}

@Component({
  selector: 'app-mini-env-img-card-slide',
  imports: [...COMMON_MODULES],
  templateUrl: './mini-env-img-card-slide.component.html',
  styleUrl: './mini-env-img-card-slide.component.scss'
})
export class MiniEnvImgCardSlideComponent {
slides: any[] = [
    {
      title: 'Medications',
      description: 'Over 1,100 medications can cause dry mouth as a side effect. Check our list or consult your healthcare professional to see if your medication is one of them.',
      bgImage: '/assets/tenant-assets/mini-env/images/old-lady.png',
    },
    {
      title: 'C-PAP – Sleep Apnea',
      description: 'Sleep apnea often leads to mouth breathing, and the constant airflow from a CPAP machine can dry out the oral cavity, causing oral health issues.',
      bgImage: '/assets/tenant-assets/mini-env/images/sleeping-in-car.png',
    },
    {
      title: 'Medical Marijuana',
      description: 'Marijuana use decreases saliva production, causing dry mouth and increasing the risk of tooth decay and gum disease.',
      bgImage: '/assets/tenant-assets/mini-env/images/medical-marijauna.png',
    },
    {
      title: 'Cancer Treatment',
      description: 'Many cancer treatments, including radiation for head and neck cancer, can directly affect the salivary glands, resulting in decreased saliva production and dry mouth.',
      bgImage: '/assets/tenant-assets/mini-env/images/cancer-treatment.png',
    },
    {
      title: 'Sjögren’s Disease',
      description: 'Inflammation of the salivary glands is common with Sjögren’s Disease, leading to dry mouth as one of the main symptoms.',
      bgImage: '/assets/tenant-assets/mini-env/images/sjogren.png'
    },
    {
      title: 'Diabetes / Other Conditions',
      description: 'Conditions like diabetes, HIV/AIDS, and Parkinson’s can cause dry mouth. Stroke patients, nursing home residents, and others in long-term care are also at risk.',
      bgImage: '/assets/tenant-assets/mini-env/images/diabetes-other.png'
    },
    {
      title: 'Neurological Diseases',
      description: 'Certain neurological conditions and other rare diseases can impair salivary function, causing dry mouth.',
      bgImage: '/assets/tenant-assets/mini-env/images/neorology-disease.png'
    },
    {
      title: 'Swallowing Disorders',
      description: 'Conditions that affect swallowing can also impact saliva production and lead to dry mouth.',
      bgImage: '/assets/tenant-assets/mini-env/images/swallowing-disorder.png'
    },
    {
      title: 'Lifestyle Choices',
      description: 'The use of marijuana, tobacco, vaping, and alcohol can decrease saliva production, leading to dry mouth.',
      bgImage: '/assets/tenant-assets/mini-env/images/lifestyle-choices.png'
    }
  ];

  currentIndex = 0;
  visibleColumns = 1;
  startX = 0;
  currentX = 0;

  ngOnInit() {
    this.updateLayout();
    this.autoSlide();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateLayout();
  }

  updateLayout() {
    const isDesktop = window.innerWidth >= 768;
    // Estimate visible columns based on 380px width to prevent over-scrolling into empty space
    this.visibleColumns = isDesktop ? Math.floor(window.innerWidth / 400) : 1;

    if (this.currentIndex > this.maxIndex()) {
      this.currentIndex = this.maxIndex();
    }
  }

  autoSlide() {
    setInterval(() => {
      if (this.currentIndex < this.maxIndex()) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    }, 2000);
  }

  onTouchStart(event: TouchEvent) {
    this.startX = event.touches[0].clientX;
  }

  onTouchMove(event: TouchEvent) {
    this.currentX = event.touches[0].clientX;
  }

  onTouchEnd() {
    const deltaX = this.currentX - this.startX;
    if (deltaX > 50 && this.currentIndex > 0) {
      this.currentIndex--;
    } else if (deltaX < -50 && this.currentIndex < this.maxIndex()) {
      this.currentIndex++;
    }
  }

  maxIndex(): number {
    // Stop sliding when the last visible card aligns with the last slide
    return Math.max(0, this.slides.length - this.visibleColumns) -1;
  }

  get dots(): number[] {
    return Array(this.maxIndex() + 1).fill(0).map((x, i) => i);
  }

  goToSlide(index: number) {
    this.currentIndex = index;
  }
}
